import useSWRMutation from 'swr/mutation'

import { IssueReceiptRequest } from '../../apis/fvillage'
import { reservationApi, tokenOptions } from '../../apis/suitebookClient'

export const useIssueReceiptApi = (id: string | number, token: string) => {
  const { trigger, error, isMutating } = useSWRMutation(
    { method: 'post', url: `/reservations/${id}/receipts`, token },
    (_key, { arg }: { arg: IssueReceiptRequest }) =>
      reservationApi
        .issueReservationReceipt(Number(id), arg, tokenOptions(token))
        .then((res) => res.data)
  )

  return { trigger, error, isMutating }
}
